<template>
  <div id="activity">
    <div class="maintop">
      <div class="action" v-if="!nowmessage">
        <div>
          <div ref="tis" v-if="lotteryData.length>2">
            <p v-for="(i,item) in lotteryData" :key="item+'a'"><img src="@/assets/images/activity/lb.png"/>恭喜<span>{{i.nickname}}抽中</span><span>{{i.prize.name}}！</span></p>  
            <p v-for="(i,item) in lotteryData" :key="item+'b'"><img src="@/assets/images/activity/lb.png"/>恭喜<span>{{i.nickname}}抽中</span><span>{{i.prize.name}}！</span></p>  
          </div>
          <div ref="tis" v-else>
            <p v-for="(i,item) in lotteryData" :key="item+'a'"><img src="@/assets/images/activity/lb.png"/>恭喜<span>{{i.nickname}}抽中</span><span>{{i.prize.name}}！</span></p>  
          </div>
        </div>
      </div>
      <div class="action ele" v-else>{{nowmessage}}</div>
      <div class="rotate">
         <div class="rotateimg" :style="rotateimgStyle">  
           <span v-for="(i,item) in prizes" :key="item">{{i.name}}</span>
          </div>
        <img class="pointer" @click="luckyDraw" src="../assets/images/activity/pointer.png" alt="pointer" />
      </div>
      <p class="times">
        <span>您今日的剩余抽奖次数：{{times}}次</span>
      </p>
    </div>
    <div class="mainbottom">

    </div>

    <van-overlay :show="care" @click="care = false">
      <div v-if="care" class="focus-wrapper">
        <div class="wrapaco">
          <p class="boomgif">恭喜您获得<span>{{goods}}</span></p>
          <p>长摁图片识别公众号，领取奖励。</p>
          <img  src="../assets/images/common/code.png" />
        </div>
      </div>
    </van-overlay>

    <van-popup v-model="show" position="bottom">
      <van-form >
        <p v-if="!first" class="boomgif addbooom">恭喜您获得<span>{{goods}}</span></p>
        <van-field
          v-model="real_name"
          type="text"
          name="姓名"
          label="姓名"
          placeholder="请填写姓名"
          :rules="[{ required: true, message: '请填写姓名' }]"
        />
        <van-field
            v-model="telephone"
            name="telephone"
            label="手机号"
            placeholder="请填写手机号"
            :rules="[{ validator, message: '请输入正确手机号' }]"
          />
        <van-field
          v-model="address"
          type="text"
          name="收货地址"
          label="收货地址"
          placeholder="请填写收货地址"
          :rules="[{ required: true, message: '请填写收货地址' }]"
        />
        <div class="sub" @click="onSubmit">
          <button >提交</button>
        </div>
      </van-form>
    </van-popup>
  
  </div>
</template>

<script>
// 关于我们

export default {
  name: 'Activity',
  created(){
    this.Global.getShareConfig({
      title: '豪礼大转盘',
      desc: '红包、话费、电扇、防晒伞等等，试试你的运气吧~'
    },this)
  },
  data(){
    return{
      rotateimgStyle:{
        color:'white'
      },
      care:false,//关注公众号
      bRotate:true,
      first:false,
      data:'',
      show:false,
      prizes:[],//奖品列表
      times:'',//次数lotteryTimes
      real_name: '',//名字
      address:'',//地址
      telephone:'',//手机号
      goods:'',
      lottery_id:'',
      lotteryData:[],
      nowmessage:'',
      timer:'',//时间
    }
  },
  methods:{
    validator(val){
      if(val.length == 11){
        return true
      }else{
        return false
      }
    },
    //提交收货地址中奖了 
    onSubmit(){
      if(!this.real_name){
        return;
      }
      if(!this.address){
        return;
      }
      if(this.telephone.length !=11){
        return;
      }
      this.axios({
        method: "POST",
        url: `/active/lottery-record`,
        headers: {
          Authorization: `Bearer ${this.Global.getCookie("token")}`
        },
        data:{
          real_name:this.real_name,
          address:this.address,
          telephone:this.telephone,
          lottery_id:this.lottery_id
        }
      }).then(res => {
        if(res.data.message == '请求成功'){
          this.$dialog.alert({
            message: '地址填写成功，奖品马上寄出，请耐心等待。'
          }).then(()=>{
            this.show = false
          })
        }
      })
    },
    // 请求抽奖
    luckyDraw(){
      if(this.times != 0){
        this.rotateimgStyle.transform="rotate(0deg)"
        this.rotateimgStyle.transition="all 0s"

        this.$forceUpdate()
        var _this = this;

        setTimeout(function(){
          _this.axios({
            method: "POST",
            url: `/active/rand-prize`,
            data:{
              lottery_id:_this.lottery_id
            },
            headers: {
              Authorization: `Bearer ${_this.Global.getCookie("token")}`
            },
          }).then(res => {
            if(res.data.code == 3){
              _this.$toast(res.data.message)
              return
            }
            // console.log(res.data.code,res.data.data.prize.type,'---')
            if(_this.times - 1>0){
              _this.times = _this.times - 1;  //抽过不能再抽了
            }else{
              _this.times = 0;
            }
            // 0  中奖 1未中奖 2抽过
            setTimeout(function(){
              if(res.data.code == 1){
                // 谢谢
                _this.$toast(res.data.message)
              }else{
                // 虚拟物品 红包
                if(res.data.data.prize.type == 2){

                  _this.goods = res.data.data.prize.name;
                  // 未关注公众号
                  if(res.data.code == 4){
                    // console.log('灭关注')
                    _this.care = true;
                  }else{
                    _this.$dialog.alert({
                      message: '恭喜您获得'+res.data.data.prize.name+',请前往公众号领取。'
                    })  
                  }
                // 实体物品
                }else if(res.data.data.prize.type == 1){
                  _this.show = true;
                  if(res.data.data.prize.prizeName){
                    _this.goods = res.data.data.prize.name + '--'+res.data.data.prize.prizeName;
                  }else{
                    _this.goods = res.data.data.prize.name
                  }
                }
              } 
            },6000)


            if(res.data.code == 1){
              // 没有
              _this.toSwitch(7)
            }else{
              // 中奖
              for(var i = 0;i<_this.prizes.length;i++){
                if(_this.prizes[i].name == res.data.data.prize.name){
                  _this.toSwitch(i)
                }
              }
            }
          })
        },100)
      }else{
        this.$toast('您的抽奖机会已用完')
      }
    },
    toSwitch(item){
      console.log(item,'item')
      switch (item) {
            case 0:
                this.rotateFn(0, 293, '0');
                break;
            case 1:
                this.rotateFn(1, -112, '1');
                break;
            case 2:
                this.rotateFn(2, 202, '2');
                break;
            case 3:
                this.rotateFn(3, 154, '3');
                break;
            case 4:
                this.rotateFn(4, 109, '4');
                break;
            case 5:
                this.rotateFn(5, 65, '5');
                break;
            case 6:
                this.rotateFn(6, 20, '6');
                break;
            case 7:
                this.rotateFn(7, 338, '7');
                break;
          }
    },
    // 转圈圈
    rotateFn(awards, angles, txt) {
        console.log( txt)
        angles = 360*5+Number(angles)
        this.rotateimgStyle.transform="rotate("+angles+"deg)"
        this.rotateimgStyle.transition="all 5s"

        this.$forceUpdate()
        this.bRotate = false;
    },
    // 获取礼物列表
    getGoodsList(){
      this.axios({
        method: "GET",
        url: `/active?data=${this.data}`,
        headers: {
          Authorization: `Bearer ${this.Global.getCookie("token")}`
        }
      }).then(res => {
        // console.log(res.data.data.is_won,res.data.data.is_won == 0,'res.data.data.is_won == 0',res.data.data.is_won == null)
        this.lottery_id = res.data.data.lottery_id;
        this.lotteryData = res.data.data.lotteryData;
        // console.log(this.lotteryData)
        if(this.lotteryData.length == 0){
          this.nowmessage = '抽奖领好礼，快来试试你的运气吧！'
        }else{
          if(this.lotteryData.length >2){
            this.timer = this.lotteryData.length*0.8+'s'
            this.$refs.tis.style.animationDuration = this.timer 
          }else{
            this.$refs.tis.style.marginTop = 0
          }
          
          // console.log(this.$refs)
        }

        if(res.data.data.is_max == 1){
          this.times = 0
          this.$toast('连接已失效')
          return;
        }
        // 先签到
        if(res.data.code == 3){
          this.prizes = res.data.data.prizes;
          if(this.prizes.length<8){
            for(var k = this.prizes.length;k<8;k++){
              this.prizes.push({name:'感谢参与'})
            }
          }
          this.times = 0
          this.$toast(res.data.message)
          return;
        }

        // 无效连接  is_won null没抽过   0 抽过 没中奖  1中奖没写地址  2写地址了
        if(res.data.code == 1){
          this.$toast(res.data.message)
          this.times = 0;
          return;
        }else if(res.data.data.is_won == 1){
          if(res.data.data.prizeType == 2){
            if(res.data.data.is_follow == 1){
              this.$dialog.alert({
                message: '奖励已发放，请前往公众号领取。'
              })
            }else{
              this.care = true;
            }
          }else{
            this.$dialog.alert({
              message: '您已中过奖，请填写收货地址。'
            }).then(()=>{
              this.show = true;
              this.first = true
            })
          }
        }else if(res.data.data.is_won === 0){
          this.times = 0
          this.prizes = res.data.data.prizes;
          if(this.prizes.length<8){
            for(var j = this.prizes.length;j<8;j++){
              this.prizes.push({name:'感谢参与'})
            }
          }
          this.$toast('暂无抽奖机会')
        }else{
          this.prizes = res.data.data.prizes;
          if(this.prizes.length<8){
            for(var i = this.prizes.length;i<8;i++){
              this.prizes.push({name:'感谢参与'})
            }
          }
        }
        // 未抽过
        // console.log(!res.data.data.is_won)
        if(res.data.data.is_won == null){
          this.times = res.data.data.lotteryTimes
        }else{
          this.times = 0
        }
      })
    }
  },
  mounted(){
    console.log(this.care)
    this.data = this.$route.query.data;
    this.getGoodsList();
  }
}
</script>

<style scoped>
@keyframes row{
    0%{}
    100%{
      transform: translateY(-50%);
    }
  }
.ele{
  justify-content: center;
}
.action>div>div>p{
  margin-left: 2.5rem;
  display: flex;
  align-items: center;
  color: #2B1212;
  font-size: 0.82rem;
  margin-bottom: 0.3rem;
  padding-right: 1rem;
}
.action>div>div>p>img{
  width: 0.97rem;
  margin-right: 1rem;
}
.action>div>div>p>span:nth-child(2){
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 5rem;
}
.action>div>div>p>span:nth-child(3){
  color: #FF3B3B;
  margin-left: 0.5rem;
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.action>div{
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 3rem;
  padding: 1.5rem 0;
  overflow: hidden;
}
.action>div>div{
  animation: row  linear infinite;
  margin-top: 6rem;
}
.action{
  width: 19.66rem;
  height: 5.5rem;
  background: url(../assets/images/activity/gd.png) no-repeat;
  background-size: 100% 100%;
  margin: 5.5rem auto;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  overflow: hidden;
}
  .focus-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
.wrapaco{
  width: 19rem;
  margin: auto;
  background: white;
  height: 21rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 1rem;
}
.wrapaco>img{
  width: 15rem;
  margin: 0 auto;
}
.boomgif{
  text-align: center;
  padding: 1rem;
  position: relative;
}
.addbooom::after{
  position: absolute;
  box-sizing: border-box;
  content: ' ';
  pointer-events: none;
  right: 0;
  bottom: 0;
  left: 16px;
  border-bottom: 1px solid #ebedf0;
  -webkit-transform: scaleY(.5);
  transform: scaleY(.5);
}
.boomgif>span{
  font-size: 1.2rem;
  color: red;
  padding: 0 0.2rem
}
.sub{
  text-align: center;
}
.sub>button{
  width: 80%;
  height: 2.5rem;
  border-radius: 2rem;
  margin: 1rem auto;
  color: white;
}
.times{
  position: absolute;
  top: 86%;
  width: 100%;
  text-align: center;
  font-size: 0.75rem;
  color: #5C0606;
  text-align: center;
}
.times>span{
  background:linear-gradient(0deg,rgba(255,220,198,1),rgba(255,252,251,1));
  box-shadow:0.01rem 0.43rem 0.875rem 0px rgba(187,109,16,0.4);
  border-radius:0.8125rem;
  padding: 0.4rem 1.1rem;
}
.rotateimg{
  width: 20rem;
  height: 20rem;
  background: url(../assets/images/activity/turntable.png) no-repeat;
  background-size: 100% 100%;
  position: relative;
  transition: all 5s;
  overflow: hidden;
}
.rotateimg span{
  position: absolute;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  text-align: center;
  line-height: 20.5rem;
}
.rotateimg span:nth-child(1){
  transform:translate(7.5rem, -3.5rem) rotate(64deg);
}
.rotateimg span:nth-child(2){
  transform: translate(7.5rem, 2.9rem) rotate(109deg);
}
.rotateimg span:nth-child(3){
  transform: translate(3.2rem, 7.5rem) rotate(158deg)
}
.rotateimg span:nth-child(4){
  transform: translate(-3.2rem, 7.3rem) rotate(205deg);
}
.rotateimg span:nth-child(5){
  transform:translate(-7.6rem, 2.7rem) rotate(250deg);
}
.rotateimg span:nth-child(6){
  transform:translate(-7.5rem, -3.3rem) rotate(293deg);
}
.rotateimg span:nth-child(7){
  transform:translate(-3rem, -7.8rem) rotate(-21deg);
}
.rotateimg span:nth-child(8){
  transform:translate(3.1rem, -7.7rem) rotate(22deg);
}

.pointer{
  width: 5.625rem;
  position: absolute;
  left: 0;
  right: 0;
  top: 30%;
  margin: auto;
}

#activity{
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column
}
#activity .maintop {
  width: 100%;
  background: url(../assets/images/activity/top.jpg);
  height: 100vh;
  background-size: 100% 100%
}

/* #activity .mainbottom{
  flex: 1;
  background: linear-gradient(0deg, #FA6A1E, #FCC862);
} */

#activity .rotate {
	width: 20rem;
	height: 20rem;
	position: absolute;
  left: 0;
  right: 0;
  top: 29%;
  margin: auto;
  overflow: hidden;
}
</style>